import React from "react";
import styles from "./NewUIBookWithUs.module.scss";
import platform from "../../../assets/new-icons/platform.svg";
import photo from "../../../assets/new-icons/photo.svg";
import health_and_safety from "../../../assets/new-icons/health_and_safety.svg";
import help from "../../../assets/new-icons/help.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const NewUIBookWithUs = () => {
  const cardsData = [
    {
      title: "All in one platform",
      image: platform,
      description:
        "Our platform simplifies your travel planning. Find everything you need in one place. From booking to detailed itineraries, we've got you covered. No more juggling multiple sites. Plan your perfect trip easily with our comprehensive, user-friendly system, saving you time and effort.",
    },
    {
      title: "expertise in Mountain destination",
      image: photo,
      description:
        "We specialize in mountain travel. Our team has in-depth knowledge of these unique locations. We understand the challenges and joys of mountain adventures. Rely on our expertise for well-planned, safe, and memorable trips. We ensure you experience the best of your chosen destination.",
    },
    {
      title: "Handpicked Stays & Experiences:",
      image: help,
      description:
        "From charming stays to breathtaking luxury retreats, and from thrilling adventures to serene cultural immersions, we bring you the finest travel moments by handpicked experiences.",
    },
    {
      title: "Safety & security",
      image: health_and_safety,
      description:
        "Your safety is our priority. We provide secure booking and reliable travel support. We carefully select our partners and accommodations. We aim to make your journey worry-free, ensuring a safe and enjoyable experience from start to finish.",
    },
  ];

  return (
    <div className={`${styles.book_from_us} `}>
      <div className="container">
        <h4 className="new_ui_heading">Why Book From Us ?</h4>

        <div className="desktop_card_sec">
          <div className={styles.cards_flex}>
            {cardsData?.map((item, i) => (
              <div
                className={styles.card}
                key={i}
                style={{ background: "#fff" }}
              >
                <img src={item.image} alt="icon" />
                <h4>{item.title}</h4>
                <p>{item?.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mobile_card_sec">
          <div className={styles.cards_flex}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              loop={true}
              slidesPerView={1}
              className="mobile_card_slider"
            >
              {cardsData?.map((item, i) => (
                <SwiperSlide key={i}>
                  <div
                    className={styles.card}
                    key={i}
                    style={{ background: "#fff" }}
                  >
                    <img src={item.image} alt="icon" />
                    <h4>{item.title}</h4>
                    <p>{item?.description}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUIBookWithUs;
